import actions from './ppt-addin.actions'
import getters from './ppt-addin.getters'
import state from './ppt-addin.state'
import mutations from './ppt-addin.mutations'

export default {
  namespaced: true,
  actions,
  getters,
  state,
  mutations,
}
